import { Skeleton, Spin } from 'antd';
import { BaseHeader } from 'components/header';
import { Role } from 'features/auth/types';
import { useAppSelector } from 'lib/store/rootReducer';
import { usePatientInfoContext } from '../_utils/patient-info/hook-context-patientinfo';
import { PatientHomeAssessmentBlockedV1Dot2 } from './components/assessment-blocked/assessment-blocked';
import { PatientHomeAssessmentUnblocked } from './components/assessment-unblocked';
import { PatientHomeClinician } from './components/patient-home-clinician/patient-home-clinician';
import { PatientHomeLayout } from './layout';
import { useGetPendingAssessmentData } from 'lib/hooks/tanstack/use-getPendingAssessmentData';

export function PatientHomeWrapper() {
  const { user, isUserDataLoading } = useAppSelector(state => state.auth);

  if (!user || isUserDataLoading) {
    return <Skeleton active />;
  }

  if ([Role.Clinician, Role.ClinicAdmin].includes(user.role)) {
    return <PatientHomeClinician />;
  }

  return <PatientHome />;
}

function PatientHome() {
  const { patientInfo, refetch } = usePatientInfoContext();
  const pendingAssessmentData = useGetPendingAssessmentData(
    patientInfo.patient.id
  );
  if (pendingAssessmentData.isLoading) {
    return <Spin />;
  }

  const patientCanStartAssessments =
    pendingAssessmentData.data?.status === true;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8
      }}
    >
      <BaseHeader headerStyle={{ background: 'none' }} />
      <PatientHomeLayout patientInfo={patientInfo}>
        {!patientCanStartAssessments && (
          <PatientHomeAssessmentBlockedV1Dot2
            patientInfo={patientInfo}
            refetchPatientInfo={refetch}
          />
        )}
        {patientCanStartAssessments && (
          <PatientHomeAssessmentUnblocked patientInfo={patientInfo} />
        )}
      </PatientHomeLayout>
    </div>
  );
}
